import React from 'react';
import { Provider } from 'react-redux';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import App from './App';
import store from './redux/configureStore';
import { registerServiceWorker } from './serviceWorkerRegistration';
import { resolveBrandName } from './utils/brandUtils';

// Before first paint, so the tab never shows the placeholder title and swaps.
document.title = resolveBrandName();

const router = createBrowserRouter([
    {
        path: '/*',
        element: <App />,
    },
]);

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
    <Provider store={store}>
        <RouterProvider router={router} />
    </Provider>
);

registerServiceWorker();
